var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9375 3.2002H13.875L12.5469 1.48145C12.1953 1.0127 11.6484 0.700195 11.0625 0.700195H7.9375C7.3125 0.700195 6.76562 1.0127 6.41406 1.48145L5.125 3.2002H1.0625C0.867188 3.2002 0.75 3.35645 0.75 3.5127V4.1377C0.75 4.33301 0.867188 4.4502 1.0625 4.4502H1.76562L3.09375 19.0205C3.17188 19.958 3.95312 20.7002 4.92969 20.7002H14.0312C15.0078 20.7002 15.7891 19.958 15.8672 19.0205L17.1953 4.4502H17.9375C18.0938 4.4502 18.25 4.33301 18.25 4.1377V3.5127C18.25 3.35645 18.0938 3.2002 17.9375 3.2002ZM7.42969 2.22363C7.54688 2.06738 7.70312 1.98926 7.9375 1.9502H11.0625C11.2578 1.98926 11.4141 2.06738 11.5312 2.22363L12.3125 3.2002H6.6875L7.42969 2.22363ZM14.6562 18.9033C14.6172 19.2158 14.3438 19.4502 14.0312 19.4502H4.92969C4.61719 19.4502 4.34375 19.2158 4.34375 18.9033L3.05469 4.4502H15.9453L14.6562 18.9033Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.85a870f7.svg";
export { ForwardRef as ReactComponent };